module.exports = __webpack_public_path__ + "static/media/recardioob-nav.ec59e1cc.png";